import React from "react";
import { type Answer } from "features/Library/Assessments/types/state";
import { type AnswerPropsBase } from "features/Library/Common/QuestionsForm/types";
import { TextAnswer } from "features/Library/Common/QuestionsForm/Answers/AnswerFields/TextAnswer";

export type SingleTextAnswerProps = AnswerPropsBase<Answer>;

export const AssessmentSingleTextAnswer = (props: SingleTextAnswerProps) => {
  const { index, answer, onBlur, onChanged, disabled, validatedFieldProps, propertyNamePrefix } = props;

  const checkboxFieldPropertyName = `${propertyNamePrefix}question.correctAnswer`;
  const inputFieldPropertyName = `${propertyNamePrefix}answers.${index}.answer.text`;

  return (
    <TextAnswer
      answer={answer.answer.text}
      index={index}
      onBlur={onBlur}
      onChanged={onChanged}
      validatedFieldProps={validatedFieldProps}
      answerFieldPropertyName={inputFieldPropertyName}
      checkboxFieldPropertyName={checkboxFieldPropertyName}
      disabled={disabled}
      isChecked={answer.answer.isCorrect}
      radio
      id={`${propertyNamePrefix}.${index}`}
    />
  );
};
